// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OrderDetail_order__8QJeK {
  color: var(--darkGray);
}

.OrderDetail_header__mIUTh {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 5px;
}

.OrderDetail_title__\\+aDNf {
  font-family: BebasNeue;
  font-weight: 700;
  color: var(--darkGray);
  font-size: 20px;
}

.OrderDetail_green__mBDZe {
  color: var(--orange);
}

.OrderDetail_clientInfo__7xXOV {
  background-color: var(--darkGray);
  color: white;
  padding: 10px 20px;
  font-weight: 500;
  margin-top: 5px;
  margin-bottom: 25px;
}

.OrderDetail_clientDetail__EdAlz {
  display: block;
}

.OrderDetail_labelClient__6O49e {
  display: inline-block;
  margin-right: 5px;
}

.OrderDetail_clientAddress__5uHaK {
  text-align: center;
}

.OrderDetail_clientPhone__9IjFn {
  text-align: right;
}

.OrderDetail_products__CeR57 {
  margin-bottom: 15px;
}

.OrderDetail_product__hRTR1 {
  border-bottom: 1px dashed #bfbfbf;
  padding-bottom: 20px;
  margin-bottom: 15px;
}

.OrderDetail_bullet__50GUp {
  display: inline-block !important;
  margin-right: 25px;
}

.OrderDetail_productName__xtkCy {
  font-family: BebasNeue;
  font-size: 18px;
}

.OrderDetail_details__FLiRM {
  padding-left: 25px;
  margin-top: 5px;
}

.OrderDetail_details__FLiRM span {
  display: block;
}

.OrderDetail_totalProduct__wH8Hz {
  display: flex;
  justify-content: flex-end;
  padding: 0 15px;
}

.OrderDetail_deliveryWrap__-rw26 {
  background-color: #f3f3f3;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
}

.OrderDetail_price__SQbUP {
  font-weight: 500;
}

.OrderDetail_label__6gqJI {
  font-weight: 500;
  font-size: 13px;
}

.OrderDetail_tipWrap__Z4kfg {
  padding: 15px;
  margin: 5px 0;
  border-bottom: 1px dashed #bfbfbf;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.OrderDetail_totalWrap__503dZ {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
}

.OrderDetail_totalPrice__ra8jo {
  font-size: 15px;
  font-weight: 700;
}

.OrderDetail_ticket__x949f {
  font-weight: 800;
}

.OrderDetail_labelSection__bYOM\\+ {
  font-family: BebasNeue;
  font-weight: 700;
  margin-bottom: 5px;
  display: block;
}

.OrderDetail_methodWrap__239zc {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 15px;
  border-top: 1px solid #c2c2c2;
  color: #444444;
}

.OrderDetail_methodWrap__239zc:last-child {
  border-bottom: 1px solid #c2c2c2;
}

.OrderDetail_cashback__UB5dX {
  font-weight: 700;
}

.OrderDetail_method__DFrvk {
  display: flex;
  align-items: center;
}

.OrderDetail_methodIcon__qFw5u {
  margin-right: 15px;
}

.OrderDetail_paymentWrap__v567d {
  margin-bottom: 30px;
}

.OrderDetail_driverName__v1lkj {
  font-weight: 700;
}

.OrderDetail_selectDriver__AQ1D- {
  width: 100%;
  border-color: #d2d2d2;
  background-color: #fbfbfb;
}

.OrderDetail_selectDriver__AQ1D- .OrderDetail_ant-select-selector__YwVgu {
  border-radius: 6px !important;
}

.OrderDetail_driverAssign__BGwdn,
.OrderDetail_accept__vXqYX,
.OrderDetail_saveNotes__n9s5l {
  font-weight: 700;
  font-size: 12px;
}

.OrderDetail_driverAssign__BGwdn {
  margin: 0 auto;
  display: block;
  width: 100%;
}

.OrderDetail_saveNotesWrap__2AoOI {
  display: flex;
  justify-content: flex-end;
}

.OrderDetail_saveNotes__n9s5l {
  width: 150px;
  margin-top: 10px;
}

.OrderDetail_historyWrap__mHlLM {
  margin-top: 30px;
}

.OrderDetail_prevOrder__AkPbM {
  border-top: 1px solid #c2c2c2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 25px;
}

.OrderDetail_prevOrder__AkPbM:last-child {
  border-bottom: 1px solid #c2c2c2;
}

.OrderDetail_seeMore__yce7h {
  display: block;
  text-align: right;
  margin-top: 10px;
  text-decoration: underline;
  color: var(--darkGray);
}

.OrderDetail_seeMore__yce7h:hover {
  color: var(--darkGray);
}

.OrderDetail_stepsWrap__ta80H {
  margin-top: 30px;
  border: 1px dashed #a8a8a8;
  background-color: #f3f3f3;
  border-radius: 4px;
  padding: 30px;
}

.OrderDetail_step__-\\+fWO {
  display: flex;
  border-top: 1px solid #d5d5d5;
  padding: 10px 15px;
  align-items: center;
  justify-content: space-between;
}

.OrderDetail_step__-\\+fWO:last-child {
  border-bottom: 1px solid #d5d5d5;
}

.OrderDetail_submitWrap__l\\+x5u {
  margin-top: 40px;
  display: flex;
  justify-content: flex-end;
}

.OrderDetail_accept__vXqYX {
  width: 200px;
}

.OrderDetail_reject__qT4-x {
  margin-right: 20px;
}

.OrderDetail_annotations__ioOzt {
  margin: 25px 0;
  color: var(--darkGray);
}

.OrderDetail_labelNotes__-8UKl {
  font-weight: 700;
}

.OrderDetail_mainInfoWrap__qyrrO {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.OrderDetail_call__fECxs {
  padding: 5px 15px;
  background-color: var(--orange);
  color: white;
  font-weight: 700;
  margin-left: 20px;
  border-radius: 4px;
  display: block;
}

.OrderDetail_step__-\\+fWO span:first-child {
  margin-right: 15px;
}

.OrderDetail_step__-\\+fWO span:last-child {
  text-align: right;
}

.OrderDetail_discount__r4h7- {
  width: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  /* font-size: 15px; */
}

.OrderDetail_reasonWrap__ME568 {
  margin-top: 30px;
}

.OrderDetail_warning__\\+I-zS {
  margin-bottom: 20px;
}

@media only screen and (max-width: 992px) {
  .OrderDetail_mainInfoWrap__qyrrO {
    justify-content: space-between;
    margin-bottom: 20px;
    margin-top: -25px;
    display: flex;
  }

  .OrderDetail_paymentWrap__v567d {
    margin-top: 20px;
  }

  .OrderDetail_clientAddress__5uHaK {
    text-align: left;
  }

  .OrderDetail_clientPhone__9IjFn {
    text-align: left;
    color: #444444;
  }

  .OrderDetail_labelClient__6O49e {
    display: block;
    color: var(--darkGray);
    font-size: 12px;
  }

  .OrderDetail_clientDetail__EdAlz {
    margin-bottom: 15px;
  }

  .OrderDetail_clientInfo__7xXOV {
    background-color: transparent;
    color: #444444;
    font-weight: 500;
    font-size: 13px;
    padding-left: 0;
  }

  .OrderDetail_submitWrap__l\\+x5u {
    width: 100%;
  }

  .OrderDetail_accept__vXqYX {
    width: 100%;
  }
}

pre {
  outline: 1px solid #ccc; padding: 5px; margin: 5px;
}

.OrderDetail_string__NPYbC { color: green;
}

.OrderDetail_number__iBwDn { color: darkorange;
}

.OrderDetail_boolean__BQzWM { color: blue;
}

.OrderDetail_null__NA2QY { color: magenta;
}

.OrderDetail_key__14kKZ { color: red;
}

.OrderDetail_btnGC__LjU-0 { border:0 !important; background:transparent !important;
}

.OrderDetail_peyaIconText__DJMUC {
  display:inline-block;
  margin-right: 2em;
}

.OrderDetail_hotstopCard__-bIZI {
  background: #fafafa;
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(0,0,0,.04);
  border: 1px solid #f0f0f0;
  margin-bottom: 20px;
}

.OrderDetail_hotstopIcon__dJDwX {
  font-size: 16px;
  line-height: 1;
  margin-right: 4px;
}

.OrderDetail_hotstopLabel__1lHFR {
  font-weight: 600;
  color: #555;
  margin-right: 6px;
}
`, "",{"version":3,"sources":["webpack://./src/components/styles/OrderDetail.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,iCAAiC;EACjC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;;EAGE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,6BAA6B;IAC7B,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;AACA;EAAK,uBAAuB,EAAE,YAAY,EAAE,WAAW;AAAE;;AACzD,6BAAU,YAAY;AAAE;;AACxB,6BAAU,iBAAiB;AAAE;;AAC7B,8BAAW,WAAW;AAAE;;AACxB,2BAAQ,cAAc;AAAE;;AACxB,0BAAO,UAAU;AAAE;;AACnB,4BAAS,mBAAmB,EAAE,iCAAiC;AAAE;;AACjE;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,qCAAqC;EACrC,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB","sourcesContent":[".order {\n  color: var(--darkGray);\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 5px;\n}\n\n.title {\n  font-family: BebasNeue;\n  font-weight: 700;\n  color: var(--darkGray);\n  font-size: 20px;\n}\n\n.green {\n  color: var(--orange);\n}\n\n.clientInfo {\n  background-color: var(--darkGray);\n  color: white;\n  padding: 10px 20px;\n  font-weight: 500;\n  margin-top: 5px;\n  margin-bottom: 25px;\n}\n\n.clientDetail {\n  display: block;\n}\n\n.labelClient {\n  display: inline-block;\n  margin-right: 5px;\n}\n\n.clientAddress {\n  text-align: center;\n}\n\n.clientPhone {\n  text-align: right;\n}\n\n.products {\n  margin-bottom: 15px;\n}\n\n.product {\n  border-bottom: 1px dashed #bfbfbf;\n  padding-bottom: 20px;\n  margin-bottom: 15px;\n}\n\n.bullet {\n  display: inline-block !important;\n  margin-right: 25px;\n}\n\n.productName {\n  font-family: BebasNeue;\n  font-size: 18px;\n}\n\n.details {\n  padding-left: 25px;\n  margin-top: 5px;\n}\n\n.details span {\n  display: block;\n}\n\n.totalProduct {\n  display: flex;\n  justify-content: flex-end;\n  padding: 0 15px;\n}\n\n.deliveryWrap {\n  background-color: #f3f3f3;\n  border-radius: 8px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 15px;\n}\n\n.price {\n  font-weight: 500;\n}\n\n.label {\n  font-weight: 500;\n  font-size: 13px;\n}\n\n.tipWrap {\n  padding: 15px;\n  margin: 5px 0;\n  border-bottom: 1px dashed #bfbfbf;\n  margin-bottom: 15px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.totalWrap {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 15px;\n}\n\n.totalPrice {\n  font-size: 15px;\n  font-weight: 700;\n}\n\n.ticket {\n  font-weight: 800;\n}\n\n.labelSection {\n  font-family: BebasNeue;\n  font-weight: 700;\n  margin-bottom: 5px;\n  display: block;\n}\n\n.methodWrap {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 15px;\n  border-top: 1px solid #c2c2c2;\n  color: #444444;\n}\n\n.methodWrap:last-child {\n  border-bottom: 1px solid #c2c2c2;\n}\n\n.cashback {\n  font-weight: 700;\n}\n\n.method {\n  display: flex;\n  align-items: center;\n}\n\n.methodIcon {\n  margin-right: 15px;\n}\n\n.paymentWrap {\n  margin-bottom: 30px;\n}\n\n.driverName {\n  font-weight: 700;\n}\n\n.selectDriver {\n  width: 100%;\n  border-color: #d2d2d2;\n  background-color: #fbfbfb;\n}\n\n.selectDriver .ant-select-selector {\n  border-radius: 6px !important;\n}\n\n.driverAssign,\n.accept,\n.saveNotes {\n  font-weight: 700;\n  font-size: 12px;\n}\n\n.driverAssign {\n  margin: 0 auto;\n  display: block;\n  width: 100%;\n}\n\n.saveNotesWrap {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.saveNotes {\n  width: 150px;\n  margin-top: 10px;\n}\n\n.historyWrap {\n  margin-top: 30px;\n}\n\n.prevOrder {\n  border-top: 1px solid #c2c2c2;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 25px;\n}\n\n.prevOrder:last-child {\n  border-bottom: 1px solid #c2c2c2;\n}\n\n.seeMore {\n  display: block;\n  text-align: right;\n  margin-top: 10px;\n  text-decoration: underline;\n  color: var(--darkGray);\n}\n\n.seeMore:hover {\n  color: var(--darkGray);\n}\n\n.stepsWrap {\n  margin-top: 30px;\n  border: 1px dashed #a8a8a8;\n  background-color: #f3f3f3;\n  border-radius: 4px;\n  padding: 30px;\n}\n\n.step {\n  display: flex;\n  border-top: 1px solid #d5d5d5;\n  padding: 10px 15px;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.step:last-child {\n  border-bottom: 1px solid #d5d5d5;\n}\n\n.submitWrap {\n  margin-top: 40px;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.accept {\n  width: 200px;\n}\n\n.reject {\n  margin-right: 20px;\n}\n\n.annotations {\n  margin: 25px 0;\n  color: var(--darkGray);\n}\n\n.labelNotes {\n  font-weight: 700;\n}\n\n.mainInfoWrap {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 20px;\n}\n\n.call {\n  padding: 5px 15px;\n  background-color: var(--orange);\n  color: white;\n  font-weight: 700;\n  margin-left: 20px;\n  border-radius: 4px;\n  display: block;\n}\n\n.step span:first-child {\n  margin-right: 15px;\n}\n\n.step span:last-child {\n  text-align: right;\n}\n.discount {\n  width: 22px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  /* font-size: 15px; */\n}\n\n.reasonWrap {\n  margin-top: 30px;\n}\n\n.warning {\n  margin-bottom: 20px;\n}\n\n@media only screen and (max-width: 992px) {\n  .mainInfoWrap {\n    justify-content: space-between;\n    margin-bottom: 20px;\n    margin-top: -25px;\n    display: flex;\n  }\n\n  .paymentWrap {\n    margin-top: 20px;\n  }\n\n  .clientAddress {\n    text-align: left;\n  }\n\n  .clientPhone {\n    text-align: left;\n    color: #444444;\n  }\n\n  .labelClient {\n    display: block;\n    color: var(--darkGray);\n    font-size: 12px;\n  }\n\n  .clientDetail {\n    margin-bottom: 15px;\n  }\n\n  .clientInfo {\n    background-color: transparent;\n    color: #444444;\n    font-weight: 500;\n    font-size: 13px;\n    padding-left: 0;\n  }\n\n  .submitWrap {\n    width: 100%;\n  }\n\n  .accept {\n    width: 100%;\n  }\n}\npre {outline: 1px solid #ccc; padding: 5px; margin: 5px; }\n.string { color: green; }\n.number { color: darkorange; }\n.boolean { color: blue; }\n.null { color: magenta; }\n.key { color: red; }\n.btnGC { border:0 !important; background:transparent !important; }\n.peyaIconText {\n  display:inline-block;\n  margin-right: 2em;\n}\n\n.hotstopCard {\n  background: #fafafa;\n  border-radius: 12px;\n  box-shadow: 0 1px 2px rgba(0,0,0,.04);\n  border: 1px solid #f0f0f0;\n  margin-bottom: 20px;\n}\n\n.hotstopIcon {\n  font-size: 16px;\n  line-height: 1;\n  margin-right: 4px;\n}\n\n.hotstopLabel {\n  font-weight: 600;\n  color: #555;\n  margin-right: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"order": `OrderDetail_order__8QJeK`,
	"header": `OrderDetail_header__mIUTh`,
	"title": `OrderDetail_title__+aDNf`,
	"green": `OrderDetail_green__mBDZe`,
	"clientInfo": `OrderDetail_clientInfo__7xXOV`,
	"clientDetail": `OrderDetail_clientDetail__EdAlz`,
	"labelClient": `OrderDetail_labelClient__6O49e`,
	"clientAddress": `OrderDetail_clientAddress__5uHaK`,
	"clientPhone": `OrderDetail_clientPhone__9IjFn`,
	"products": `OrderDetail_products__CeR57`,
	"product": `OrderDetail_product__hRTR1`,
	"bullet": `OrderDetail_bullet__50GUp`,
	"productName": `OrderDetail_productName__xtkCy`,
	"details": `OrderDetail_details__FLiRM`,
	"totalProduct": `OrderDetail_totalProduct__wH8Hz`,
	"deliveryWrap": `OrderDetail_deliveryWrap__-rw26`,
	"price": `OrderDetail_price__SQbUP`,
	"label": `OrderDetail_label__6gqJI`,
	"tipWrap": `OrderDetail_tipWrap__Z4kfg`,
	"totalWrap": `OrderDetail_totalWrap__503dZ`,
	"totalPrice": `OrderDetail_totalPrice__ra8jo`,
	"ticket": `OrderDetail_ticket__x949f`,
	"labelSection": `OrderDetail_labelSection__bYOM+`,
	"methodWrap": `OrderDetail_methodWrap__239zc`,
	"cashback": `OrderDetail_cashback__UB5dX`,
	"method": `OrderDetail_method__DFrvk`,
	"methodIcon": `OrderDetail_methodIcon__qFw5u`,
	"paymentWrap": `OrderDetail_paymentWrap__v567d`,
	"driverName": `OrderDetail_driverName__v1lkj`,
	"selectDriver": `OrderDetail_selectDriver__AQ1D-`,
	"ant-select-selector": `OrderDetail_ant-select-selector__YwVgu`,
	"driverAssign": `OrderDetail_driverAssign__BGwdn`,
	"accept": `OrderDetail_accept__vXqYX`,
	"saveNotes": `OrderDetail_saveNotes__n9s5l`,
	"saveNotesWrap": `OrderDetail_saveNotesWrap__2AoOI`,
	"historyWrap": `OrderDetail_historyWrap__mHlLM`,
	"prevOrder": `OrderDetail_prevOrder__AkPbM`,
	"seeMore": `OrderDetail_seeMore__yce7h`,
	"stepsWrap": `OrderDetail_stepsWrap__ta80H`,
	"step": `OrderDetail_step__-+fWO`,
	"submitWrap": `OrderDetail_submitWrap__l+x5u`,
	"reject": `OrderDetail_reject__qT4-x`,
	"annotations": `OrderDetail_annotations__ioOzt`,
	"labelNotes": `OrderDetail_labelNotes__-8UKl`,
	"mainInfoWrap": `OrderDetail_mainInfoWrap__qyrrO`,
	"call": `OrderDetail_call__fECxs`,
	"discount": `OrderDetail_discount__r4h7-`,
	"reasonWrap": `OrderDetail_reasonWrap__ME568`,
	"warning": `OrderDetail_warning__+I-zS`,
	"string": `OrderDetail_string__NPYbC`,
	"number": `OrderDetail_number__iBwDn`,
	"boolean": `OrderDetail_boolean__BQzWM`,
	"null": `OrderDetail_null__NA2QY`,
	"key": `OrderDetail_key__14kKZ`,
	"btnGC": `OrderDetail_btnGC__LjU-0`,
	"peyaIconText": `OrderDetail_peyaIconText__DJMUC`,
	"hotstopCard": `OrderDetail_hotstopCard__-bIZI`,
	"hotstopIcon": `OrderDetail_hotstopIcon__dJDwX`,
	"hotstopLabel": `OrderDetail_hotstopLabel__1lHFR`
};
export default ___CSS_LOADER_EXPORT___;
